import { render, staticRenderFns } from "./AdminSIMCardList.vue?vue&type=template&id=130ee4e6&scoped=true&"
import script from "./AdminSIMCardList.vue?vue&type=script&lang=js&"
export * from "./AdminSIMCardList.vue?vue&type=script&lang=js&"
import style0 from "./AdminSIMCardList.vue?vue&type=style&index=0&id=130ee4e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ee4e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130ee4e6')) {
      api.createRecord('130ee4e6', component.options)
    } else {
      api.reload('130ee4e6', component.options)
    }
    module.hot.accept("./AdminSIMCardList.vue?vue&type=template&id=130ee4e6&scoped=true&", function () {
      api.rerender('130ee4e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminSIMCardList.vue"
export default component.exports